import React, { useState, useEffect } from 'react'
import { Redirect, Switch, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Layout } from '../_metronic/layout'

import RoutesConfig, {
    factoryAdminRoutes,
    userRoutes,
    AdvertisingAdminRoutes,
} from './Routes'
import PublicRoute from './PublicRoutes'
import PrivateRoute from './PrivateRoutes'
import { Logout, AuthPage } from '../app/pages/Auth'
import RegisterContextProvider from '../app/components/contexts/authContext/AuthContextProvider'
import { useGetAUserByToken } from '../app/components/customHooks/users/userHooks'
const RouteProvider = () => {
    const token = localStorage.getItem('token')

    const [isLogin, setIsLogin] = useState(false)
    // const { user } = useSelector((state) => state.user);
    const { user } = useGetAUserByToken()
    useEffect(() => {
        if (token) {
            setIsLogin(true)
        }
    }, [token])

    const isAdmin = () => user?.roles.filter(item => item.name === 'admin')

    return (
        <Switch>
            <Route path="/auth/logout" component={Logout} exact={true} />
            {isLogin && user && user?.roles && isAdmin().length > 0 ? (
                <Layout>
                    <Route path={['/dashboard']}>
                        <Switch>
                            {RoutesConfig.map(
                                ({
                                    Component,
                                    RouteType,
                                    path,
                                    RouteID,
                                    exact,
                                    context,
                                    SubRoutes,
                                }) => (
                                    <PrivateRoute
                                        key={RouteID}
                                        path={path}
                                        component={Component}
                                        exact={exact}
                                        context={context}
                                        sub={SubRoutes}
                                    />
                                )
                            )}
                        </Switch>
                    </Route>
                </Layout>
            ) : isLogin &&
              user &&
              user?.roles &&
              user?.roles[0]?.name === 'customer' ? (
                <Layout>
                    <Route path={['/dashboard']}>
                        <Switch>
                            {userRoutes.map(
                                ({
                                    Component,
                                    RouteType,
                                    path,
                                    RouteID,
                                    exact,
                                    context,
                                    SubRoutes,
                                }) => (
                                    <PrivateRoute
                                        key={RouteID}
                                        path={path}
                                        component={Component}
                                        exact={exact}
                                        context={context}
                                        sub={SubRoutes}
                                    />
                                )
                            )}
                        </Switch>
                    </Route>
                </Layout>
            ) : isLogin &&
              user &&
              user?.roles &&
              user?.roles[0]?.name === 'factory_admin' ? (
                <Layout>
                    <Route path={['/dashboard']}>
                        <Switch>
                            {factoryAdminRoutes.map(
                                ({
                                    Component,
                                    RouteType,
                                    path,
                                    RouteID,
                                    exact,
                                    context,
                                    SubRoutes,
                                }) => (
                                    <PrivateRoute
                                        key={RouteID}
                                        path={path}
                                        component={Component}
                                        exact={exact}
                                        context={context}
                                        sub={SubRoutes}
                                    />
                                )
                            )}
                        </Switch>
                    </Route>
                </Layout>
            ) : (
                isLogin &&
                user &&
                user?.roles &&
                user?.roles[0]?.name === 'advertising_admin' && (
                    <Layout>
                        <Route path={['/dashboard']}>
                            <Switch>
                                {AdvertisingAdminRoutes.map(
                                    ({
                                        Component,
                                        RouteType,
                                        path,
                                        RouteID,
                                        exact,
                                        context,
                                        SubRoutes,
                                    }) => (
                                        <PrivateRoute
                                            key={RouteID}
                                            path={path}
                                            component={Component}
                                            exact={exact}
                                            context={context}
                                            sub={SubRoutes}
                                        />
                                    )
                                )}
                            </Switch>
                        </Route>
                    </Layout>
                )
            )
            //  : (
            //   <Layout>
            //     <Route path={["/dashboard"]}>
            //       <Switch></Switch>
            //     </Route>
            //   </Layout>
            // )
            }
            <Route path={['/auth']}>
                <RegisterContextProvider>
                    <PublicRoute path="/auth" component={AuthPage} />
                </RegisterContextProvider>
            </Route>
            {localStorage.getItem('token') ? (
                <Redirect from="/" to={window.location.pathname} />
            ) : (
                <Redirect from="/" to="/auth/login" />
            )}
        </Switch>
    )
}
export default RouteProvider
